export enum ConnectLaunchError {
  FAILED_TO_LAUNCH = 'Failed to launch Connect. Please check the URL you entered.',
  NO_ISBN_FOUND = 'No ISBN found.',
  PLEASE_PROVIDE_SECTION_URL = 'Please provide a Connect section URL.',
  COULD_NOT_FIND_SECTION_URL = 'Could not find the Connect section URL.',
  UNKNOWN_ERROR = 'Unknown error occurred.'
}
